// extracted by mini-css-extract-plugin
export var Body = "styles-module--Body--ZHcxI";
export var Close = "styles-module--Close--rARvB";
export var Success = "styles-module--Success---tu5p";